import React from "react"
import classnames from "classnames"
import { AlertIcon } from "AtomicComponents"
import styles from "./InputDate.less"
import DayPickerInput from 'react-day-picker/DayPickerInput';
import dateHandler from 'AtomicUtils/dateHandler'

class InputDate extends React.PureComponent {
  constructor(props){
    super(props)
    // for testing purposes
    if (process && process.env && process.env.NODE_ENV === 'test'){
      this.random = 1
    }else {
      this.random = Math.random()
    }
    this.state={
      selectedDay: null
    }
    this.inputDate = null
  }

  _getThisInput = (inputThis) => {
    const { getThisInput = () => { } } = this.props
    getThisInput(this.inputDate)
  }

  _dirtyClass = (value) => {
    if (this.label){
      if (value && value != "") {
        this.label.classList.add(styles.PlaceholderWithValue)
      } else {
        this.label.classList.remove(styles.PlaceholderWithValue)
      }
    }
  }

  _handleOnClickOnLabel = () => {
    this.inputDate.focus()
  }

  _handleDayChange = (selectedDay, modifiers) => {
    const { onChange = () => { } } = this.props

    this._dirtyClass(selectedDay)
    onChange(selectedDay)

    this.setState({
      selectedDay,
    });
  }

  render() {
    const {
      label,
      name,
      required,
      styleName = "light",
      isValid = true,
      type = 'text',
      focused,
      min = new Date(new Date().getTime() + (24 * 60 * 60 * 1000)),
      message,
      defaultValue
    } = this.props
    const { selectedDay=defaultValue } = this.state
    return (
      <div
        className={classnames({
          [styles.Input]: true
        })}
      >
        <div
          className={classnames({
            [styles.InputInput]: true,
            [styles.Focused]: focused,
            [styles.InputInvalid]: !isValid,
            [styles.InputDark]: styleName === "dark",
            [styles.InputLight]: styleName === "light"
          })}
        >
          <DayPickerInput
            component={props =>
              <input
                {...props}
                ref = { c => this.inputDate = c}
                name={`${name}-${this.random}`}
                type={type}
              />
            }
            format={`D/M/YYYY`}
            formatDate={(date) => new dateHandler(date).format('0D/0M/YYYY')}
            value={selectedDay}
            onDayChange={this._handleDayChange}
            dayPickerProps={{
              selectedDays: selectedDay,
              disabledDays: { before: min }
            }}
            placeholder={''}
          />
        </div>
        <label
          ref={c => this.label = c}
          htmlFor={`${name}-${this.random}`}
          onClick={this._handleOnClickOnLabel}
          className={classnames({
            [styles.Placeholder]: true,
            [styles.PlaceholderWithValue]: false
          })}>
          {label}
          {required &&
            <span className={classnames({
              [styles.requiredStar]: true
            })}>*</span>
          }
        </label>
        <div className={classnames({
          [styles.icon]: true,
          [styles.iconShow]: !isValid
        })}>
          <AlertIcon style={{height:"1em", width: "1em"}} />
        </div>
        <div className={classnames({
          [styles.message]: true,
          [styles.messageShow]: !isValid
        })}>
          {message}
        </div>
      </div>
    )
  }
}


export default InputDate



// WEBPACK FOOTER //
// ./src/AtomicContainers/InputDate/InputDate.jsx